import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomHttp } from '../../../common/customHttp.service';
import { CharsGroupingService } from '../../../common/charsgrouping.service';
import { ApiUrl } from '../../../common/apiUrls';
import { MainAppComponent } from '../../../layout/layout.component';
import { ToastrService } from 'ngx-toastr';
import { JobCardModel } from '../../../common/viewModels/Analysis/SampleModel';

@Component({
    selector: 'jobcardchars',
    templateUrl: './jobcardchars.component.html',
    // styleUrls: ['./jobcardchars.component.scss']
})
export class JobCardCharsComponent implements OnInit {

    lstJobCardChars: any[];
    lstJobCardCharsTemp: any[];
    JobCardId: number;
    jobCardChars: JobCardModel = new JobCardModel();
    isCompressed: boolean = false;


    constructor(public _router: Router,
        private _http: CustomHttp,
        private _appUrl: ApiUrl, private _route: ActivatedRoute, private _mApp: MainAppComponent,
        private _toastrService: ToastrService,private _charsGrpSrvc: CharsGroupingService
    ) {

    }

    ngOnInit() {
        this.JobCardId = this._route.snapshot.params['id'];
        this.GetListOfJobCardChars(this.JobCardId);

    }

    GetListOfJobCardChars(jobCardId) {
        this._mApp.ShowLoader();
        this._http.get(this._appUrl.GetListOfJobCardChars + jobCardId)
            .subscribe(
                data => {
                    if (data.json().Result != null) {
                        this.lstJobCardChars = data.json().Result;
                        this.lstJobCardCharsTemp = data.json().Result;
                    }
                    this._mApp.HideLoader();
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    OnSubmit() {
        this._mApp.ShowLoader();
        let values = [];
        for (let item of this.lstJobCardCharsTemp) {
            if (item.SubCharcteristics != null && item.SubCharcteristics != "" && item.SubCharcteristics != undefined) {
                for (let item2 of item.SubCharcteristics) {
                    if (item2.IsChecked)
                        values.push(item2.CharacteristicId)
                }
            }
            else if (item.IsChecked) {
                values.push(item.CharacteristicId)
            }
        }

        this.jobCardChars.JobCardId = this.JobCardId;
        this.jobCardChars.lstCharIds = values;
        this._http.post(this._appUrl.UpsertJobCardChars, this.jobCardChars)
            .subscribe(
                data => {
                    this._mApp.HideLoader();
                    this._toastrService.success(data.json().Result, '');
                    this._router.navigate(['/jobcardlist']);
                },
                error => {
                    this._mApp.HideLoader();
                    this._toastrService.error(error.json().Result, '');
                }
            )
    }

    collapseDivison(index, isCollapsed) {
        this.lstJobCardChars[index].Collapsed = !isCollapsed;
    }

    checkOruncheckAll(index, event) {
        this.lstJobCardChars = this._charsGrpSrvc.checkOruncheckAll(index, event, this.lstJobCardChars);
        this.lstJobCardCharsTemp = this._charsGrpSrvc.checkOruncheckAllTemp(index, event, this.lstJobCardCharsTemp, this.lstJobCardChars);
    }

    checkOrUncheckMain(mainIndex) {
        this.lstJobCardChars = this._charsGrpSrvc.checkOrUncheckMain(mainIndex, this.lstJobCardChars);
        this.lstJobCardCharsTemp = this._charsGrpSrvc.checkOrUncheckMainTemp(mainIndex, this.lstJobCardCharsTemp, this.lstJobCardChars);
    }

    compressOrExpand() {
        if (this.lstJobCardChars != null && this.lstJobCardChars != undefined)
            for (let i = 0; i < this.lstJobCardChars.length; i++) {
                this.lstJobCardChars[i].Collapsed = !this.isCompressed;
            }
        this.isCompressed = !this.isCompressed;
    }

    specialSearch(val) {
        this.lstJobCardChars = this._charsGrpSrvc.specialSearch(val, this.lstJobCardCharsTemp);
    }

}
